import repository from '@/repositories/Repository'

const resource = '/api/private/tanawari'

export default {
  async get({ dateFrom, dateTo, company, itemCategories, keyword }) {
    return repository.giggle
      .post(`${resource}`, {
        dateFrom: dateFrom,
        dateTo: dateTo,
        company: company,
        itemCategories: itemCategories,
        keyword: keyword,
      })
      .then(r => r.data)
  },
}
